const differentiators = [
  {
    pillar: "Product Sourcing",
    icon: "ri-search-eye-line",
    stat: "< 36hrs",
    title: "Sourcing Requests Fulfilled",
    description:
      "Submit a product sourcing brief and get matched with vetted, verified supplier options in under 36 hours — any product, any category, any region.",
    color: "bg-yellow-50",
    iconColor: "text-[#C9A227]",
    pillarColor: "text-[#C9A227]",
    pillarBg: "bg-[#C9A227]/10",
    accent: "border-[#C9A227]",
  },
  {
    pillar: "Wholesale Supply",
    icon: "ri-store-3-line",
    stat: "~15%",
    title: "Average Cost Reduction",
    description:
      "Clients using our wholesale supply network have seen per-unit cost reductions through direct manufacturer access — results vary by product and volume.",
    color: "bg-[#D9E2EC]",
    iconColor: "text-[#3A506B]",
    pillarColor: "text-[#3A506B]",
    pillarBg: "bg-[#D9E2EC]",
    accent: "border-[#3A506B]",
  },
  {
    pillar: "Inventory Solutions",
    icon: "ri-archive-drawer-line",
    stat: "~70%",
    title: "Overstock Clearance Rate",
    description:
      "Our growing buyer network has helped clients move a significant portion of surplus inventory — timelines depend on product type, quantity, and market demand.",
    color: "bg-[#C9A227]/10",
    iconColor: "text-[#C9A227]",
    pillarColor: "text-[#C9A227]",
    pillarBg: "bg-[#C9A227]/10",
    accent: "border-[#C9A227]",
  },
  {
    pillar: "Global Reach",
    icon: "ri-earth-line",
    stat: "8+",
    title: "Countries Reached",
    description:
      "LTF Sourcing's supplier and buyer network is actively expanding — we currently work with partners across 8+ countries and are growing our reach every month.",
    color: "bg-teal-50",
    iconColor: "text-teal-600",
    pillarColor: "text-teal-600",
    pillarBg: "bg-teal-50",
    accent: "border-teal-400",
  },
];

const pillarProof = [
  { icon: "ri-search-eye-line", label: "Product Sourcing", value: "150+ Products Sourced" },
  { icon: "ri-store-3-line", label: "Wholesale Supply", value: "40+ Categories Available" },
  { icon: "ri-archive-drawer-line", label: "Inventory Solutions", value: "12 Supplier Partners" },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-[#C9A227] mb-3 block">
              Why LTF Sourcing
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-[#222831] leading-tight max-w-xl">
              Proven Across All Three Pillars
            </h2>
          </div>
          <p className="text-base text-gray-500 max-w-sm leading-relaxed lg:text-right">
            We&apos;re early in our journey, but already delivering real results —
            here&apos;s what our clients are seeing across all three pillars.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentiators.map((item) => (
            <div
              key={item.title}
              className={`relative rounded-2xl bg-white border border-[#D9E2EC] p-7 flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 border-t-4 ${item.accent}`}
            >
              {/* Pillar tag */}
              <div className={`self-start inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full ${item.pillarBg}`}>
                <i className={`${item.icon} text-xs ${item.pillarColor}`}></i>
                <span className={`text-xs font-bold uppercase tracking-widest ${item.pillarColor}`}>
                  {item.pillar}
                </span>
              </div>

              {/* Icon */}
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-2xl ${item.iconColor}`}></i>
              </div>

              {/* Stat */}
              <div>
                <p className={`text-3xl font-extrabold ${item.iconColor}`}>{item.stat}</p>
                <h3 className="text-base font-bold text-[#222831] mt-1">{item.title}</h3>
              </div>

              {/* Description */}
              <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom Strip */}
        <div className="mt-12 rounded-2xl bg-[#D9E2EC] border border-[#D9E2EC] px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#C9A227]/15 flex-shrink-0">
              <i className="ri-shield-star-line text-[#C9A227] text-lg"></i>
            </div>
            <p className="text-sm text-[#222831] font-medium">
              <strong>75+ businesses</strong> have already trusted LTF Sourcing across our three pillars —
              product sourcing, wholesale supply, and inventory solutions.
            </p>
          </div>
          <div className="flex items-center gap-5 flex-shrink-0">
            {pillarProof.map((p) => (
              <div key={p.label} className="flex items-center gap-1.5">
                <i className={`${p.icon} text-[#C9A227] text-base`}></i>
                <div className="flex flex-col">
                  <span className="text-xs font-extrabold text-[#222831] whitespace-nowrap leading-tight">{p.value}</span>
                  <span className="text-xs text-[#3A506B] whitespace-nowrap leading-tight">{p.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
